@keyframes _1jt1u6na {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(334%);
  }
}
._1jt1u6n0 {
  display: flex;
  flex-direction: column;
  gap: var(--xvl85n8y);
}
._1jt1u6n1 {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
}
._1jt1u6n2 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--xvl85n8z);
}
._1jt1u6n3 {
  display: flex;
  align-items: center;
  gap: var(--xvl85n8y);
  margin-left: auto;
}
._1jt1u6n4 {
  font-size: var(--xvl85n7o);
  color: var(--xvl85n8q);
}
._1jt1u6n5 {
  width: 80px;
}
._1jt1u6n6 {
  display: flex;
  flex-direction: column;
  gap: var(--xvl85n8y);
}
._1jt1u6n7 {
  margin: 0;
  font-size: var(--xvl85n7p);
  color: var(--xvl85n8k);
}
._1jt1u6n8 {
  display: flex;
  flex-direction: column;
  gap: var(--xvl85n8y);
}
._1jt1u6n9 {
  height: 2px;
  overflow: hidden;
  border-radius: var(--xvl85n9g);
  background: var(--xvl85n5);
}
._1jt1u6nb {
  display: block;
  height: 100%;
  width: 30%;
  border-radius: var(--xvl85n9g);
  background: var(--xvl85n17);
  animation: _1jt1u6na var(--xvl85ndu) var(--xvl85ne5) infinite;
}
._1jt1u6nc {
  display: block;
  height: 100%;
  border-radius: var(--xvl85n9g);
  background: var(--xvl85n17);
}
._1jt1u6nd {
  margin: 0;
  font-size: var(--xvl85n7p);
  font-variant-numeric: tabular-nums;
  color: var(--xvl85n8j);
}
._1jt1u6ne {
  display: flex;
  align-items: center;
  gap: var(--xvl85n8z);
  margin: 0;
  font-size: var(--xvl85n7p);
  color: var(--xvl85n28);
}
@media (prefers-reduced-motion: reduce) {
  ._1jt1u6nb {
    animation: none;
    transform: translateX(117%);
  }
}